export default __webpack_public_path__ + "static/media/img1.260577e1.svg";